import axios from '../modules/marketplace/axios-marketplace';

const getCategorias = (params) => axios.get('/categorias', {
  params,
});

export default {
  getCategorias,
};
